class Registrant {
  constructor({
    id = "",
    firstName = "",
    lastName = "",
    city = "",
    country = "",
    email = "",
    mobile = "",
    businessName = "",
    jobTitle = "",
    note = "",
    created = null,
  }) {
    (this.id = id),
      (this.firstName = firstName),
      (this.lastName = lastName),
      (this.city = city),
      (this.country = country),
      (this.email = email),
      (this.mobile = mobile),
      (this.businessName = businessName),
      (this.jobTitle = jobTitle),
      (this.note = note), 
      (this.created = created);
  }
  static fromObject(registrant) {
    return new Registrant({
      id: registrant.id || "",
      firstName: registrant.firstName || "",
      lastName: registrant.lastName || "",
      city: registrant.city || "",
      country: registrant.country || "",
      email: registrant.email || "",
      mobile: registrant.mobile || "",
      businessName: registrant.businessName || "",
      jobTitle: registrant.jobTitle || "",
      note: registrant.note || "",
      created: registrant.created || null,
    });
  }

  toObject() {
    return {
      id: this.id || "",
      firstName : this.firstName ||"",
      lastName : this.lastName || "",
      city : this.city || "",
      country : this.country || "",
      email : this.email || "",
      mobile : this.mobile || "",
      businessName : this.businessName || "",
      jobTitle : this.jobTitle || "",
      note : this.note || "",
      created : this.created || null
    };
  }
}

export default Registrant;
